import * as React from 'react'

function SvgDirt2Icon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.467 4.817c-.626-1.253-2.372-1.361-3.149-.196a1.824 1.824 0 0 0 .506 2.53l1.272.847a1.418 1.418 0 0 0 2.055-1.813l-.684-1.368Zm-2.317.359a.824.824 0 0 1 1.423.088l.684 1.368a.418.418 0 0 1-.606.534L5.38 6.318a.824.824 0 0 1-.229-1.142Z"
        fill="#E91630"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.61 4.904a1.781 1.781 0 0 0-2.852.462l-.938 1.875a.469.469 0 0 1-.75.122l-.176-.176a1.56 1.56 0 0 0-2.207 2.207l.122.122a.685.685 0 0 1 0 .968l-.163.162a.914.914 0 0 1-1.293 0l-.475-.475a2.268 2.268 0 0 0-3.207 3.207l.784.784c.56.56.698 1.414.344 2.12-.187.377-.332.848-.247 1.35.142.85.582 1.592 1.307 2.12.72.523 1.689.813 2.868.83.997.015 1.878-.48 2.523-1.125l.286-.287a2.29 2.29 0 0 1 2.89-.286l1.12.747a2.225 2.225 0 0 0 3.085-3.085l-.386-.58a2.075 2.075 0 0 1-.13-2.08l.7-1.398a2.462 2.462 0 0 0-.462-2.842l-.209-.21a2.051 2.051 0 0 0-2.368-.383l-.408.204a.418.418 0 0 1-.535-.606l1-1.5a1.781 1.781 0 0 0-.222-2.247Zm-1.958.91a.781.781 0 1 1 1.35.783l-1 1.5a1.418 1.418 0 0 0 1.813 2.054l.409-.204a1.051 1.051 0 0 1 1.213.197l.21.21c.444.445.555 1.124.273 1.687l-.699 1.399a3.075 3.075 0 0 0 .192 3.08l.386.58a1.225 1.225 0 0 1-1.698 1.7l-1.121-.748a3.29 3.29 0 0 0-4.15.411l-.287.287c-.518.518-1.153.842-1.801.832-1.029-.015-1.782-.266-2.295-.639a2.234 2.234 0 0 1-.91-1.477c-.035-.213.02-.463.157-.736a2.837 2.837 0 0 0-.532-3.275l-.784-.784a1.268 1.268 0 0 1 1.793-1.793l.475.476c.748.747 1.96.747 2.707 0l.163-.163a1.685 1.685 0 0 0 0-2.382l-.122-.122a.56.56 0 1 1 .793-.793l.176.176a1.469 1.469 0 0 0 2.352-.382l.937-1.874Z"
        fill="#E91630"
      />
    </svg>
  )
}

export default SvgDirt2Icon
